(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/retail-cover-image/assets/javascripts/retail-cover-image.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/retail-cover-image/assets/javascripts/retail-cover-image.js');
"use strict";


const _svs$components$marke = svs.components.marketplaceRetailAdmin.helpers.getCoverImageUrl,
  getCoverImageUrl = _svs$components$marke.getCoverImageUrl,
  getDefaultCoverImageUrl = _svs$components$marke.getDefaultCoverImageUrl;
const Image = svs.content.image_v2.Image;
const RetailCoverImage = _ref => {
  let image = _ref.image,
    _ref$classname = _ref.classname,
    classname = _ref$classname === void 0 ? '' : _ref$classname;
  const imageUrl = getCoverImageUrl(image);
  const imgObject = {
    noscriptUrl: imageUrl,
    originalImage: true
  };
  return React.createElement("div", {
    className: classname,
    id: "retail-cover-image"
  }, React.createElement(Image, {
    className: classname,
    fallbackImage: getDefaultCoverImageUrl(),
    image: imgObject,
    style: {
      display: 'block'
    }
  }));
};
setGlobal('svs.components.marketplaceRetailAdmin.retailCoverImage.RetailCoverImage', {
  RetailCoverImage
});

 })(window);